import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  saveUserAdsCampaign: {
    method: 'POST',
    url: `${configs.baseUrl}/api/user-ads-campaign/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const saveUserAdsCampaign = async (params) => {
  const res = await resource.saveUserAdsCampaign(params)
  return {
    data: res.body,
  }
}

export default {
  initResource,
  saveUserAdsCampaign,
}
